/* eslint react/prop-types: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// eslint-disable-next-line css-modules/no-unused-class
import s from './popup.css';

class PopUp extends Component {
  static propTypes = {
    handleClose: PropTypes.func
  };

  handleClose = () => {
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  };

  handlePostQRCode = () => {
    if (this.props.handlePostQRCode) {
      this.props.handlePostQRCode();
    }
  };

  handleLogin = () => {
    window.location = '/login';
  };

  render() {
    const { loginStatus, clientName } = this.props;
    return (
      <div className={s.container}>
        <div className={s.inner}>
          {loginStatus ? (
            <div className={s.header}>Request for Permission</div>
          ) : (
            <div className={s.header}>Authentication Required</div>
          )}
          <div className={s.content}>
            <p>
              {loginStatus
                ? `${clientName} is trying to access your account's credentials from other device. Allow?`
                : `You need to be logged in to login to other device via QR code`}
            </p>
          </div>
          {loginStatus ? (
            <div className={s.action}>
              <span onClick={this.handleClose}>No</span>
              <span onClick={this.handlePostQRCode}>Yes</span>
            </div>
          ) : (
            <div className={s.action}>
              <span onClick={this.handleClose}>Close</span>
              <span onClick={this.handleLogin}>Log In</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(PopUp);
